import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  statusMessage(_i) {
    return 'Status message!';
  },
  failureReason(_i) {
    return '';
  },
  status(i) {
    return faker.list.cycle('queued', 'done', 'failed')(i);
  },
  pluginName(i) {
    return faker.list.cycle('Meraki', 'Cisco', 'Slack', 'Yo', 'IRC', 'IIRC')(i);
  },
  pluginCategory(i) {
    return faker.list.cycle('wi-fi', 'crm', 'security')(i);
  },

  wifiDone: trait({
    failureReason: null,
    pluginName: 'Cisco Meraki',
    pluginCategory: 'wi-fi',
    status: 'done',
    statusMessage: 'Wi-Fi password generated: 997671',
  }),
});
